"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Je wil groeien en weet dat je daar de juiste mensen bij nodig hebt.", "Je voelt dat er meer in zit, maar de dagelijkse drukte houdt je tegen.", "Je bent klaar om AI te omarmen zonder het menselijke te verliezen.", "Je wil slimmer werken, niet harder, en tijd terugwinnen voor wat écht telt.", "Je zoekt geen leverancier maar een partner die met je meedenkt en meebouwt.", "Je bent klaar voor de volgende stap en wil die niet alleen zetten."];
export default function CareersAtVanDijkPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="87519" id="samenwerken" className="text-foreground py-16 !bg-[hsl(20,100%,98%)] md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className="border-accent/30 border-dashed relative overflow-hidden rounded-2xl border px-6 py-12 transition-all duration-1000 translate-y-0 opacity-100 !bg-[hsl(20,100%,98%)] sm:px-12 md:py-16 lg:px-16 xl:p-20">
          <div className="absolute -bottom-14 -left-14 w-24 h-24 bg-accent/5 rounded-lg -z-30" />
          <div className="absolute -top-14 -right-14 w-32 h-32 bg-accent/5 rounded-lg -z-30" />
          
          <div className="bg-accent/10 absolute top-0 right-0 -mt-16 -mr-16 size-64 rounded-lg blur-3xl" />
          <div className="bg-accent/10 absolute bottom-0 left-0 -mb-16 -ml-16 size-64 rounded-lg blur-3xl" />

          <div className="relative z-10 grid gap-12 lg:grid-cols-2 lg:gap-8 xl:gap-16">
            <div className="flex flex-col justify-center space-y-6">
              <div className="space-y-4">
                <h2 className="font-default text-primary text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">Voelt dit als een klik?</h2>
                <p className="text-muted-foreground font-default max-w-[600px] text-lg leading-relaxed md:text-xl">Dan is er waarschijnlijk een klik. Wij werken met ondernemers die klaar zijn voor de volgende stap. Niet omdat het moet, maar omdat je weet dat stilstaan geen optie is.&nbsp;</p>
              </div>
              <div className="pt-4">
                <Button asChild size="lg" variant="default" className="text-primary-foreground font-semibold rounded-lg shadow-lg shadow-primary/10">
                  <Link to="/contact">Laten we verbinden</Link>
                </Button>
              </div>
            </div>

            <div className="flex items-center">
              <div className="grid w-full gap-4 sm:grid-cols-2 sm:gap-6">
                {benefits.map((benefit, i) => <div key={i} data-index={i} className="bg-background/80 border-border/50 flex items-start space-x-3 rounded-xl border p-4 shadow-sm backdrop-blur-md">
                    <CircleCheck className="text-accent-foreground mt-0.5 size-5 shrink-0" />
                    <span className="text-primary font-default font-medium leading-snug">
                      {benefit}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}